import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: false
})
export class StripHtmlPipe implements PipeTransform {

    transform(text: string, ...usefulTags: any[]): string {

        if (!text) return '';

        return usefulTags?.length > 0
            ? text.replace(new RegExp(`<(?!\/?(${usefulTags.join('|')})\s*\/?)[^>]+>`, 'g'), '')
            : text.replace(/<(?:.|\s)*?>/g, '');
    }

}

@NgModule({
    imports: [CommonModule],
    declarations: [StripHtmlPipe],
    providers: [StripHtmlPipe],
    exports: [StripHtmlPipe],
})
export class StripHtmlPipeModule { }